import { ActiveMarkup, FokParameterChoiceInput } from '@fora-monorepo/employer-my-pages-common/types';
import { HIGH_DATE_S4I } from '@fora-monorepo/employer-my-pages-common/utils';

export const getParameterChoiceInput = (
  parameterChoicesInput: {
    fokParameter: FokParameterChoiceInput;
    validateInput: () => boolean;
  }[],
  activeMarkup: ActiveMarkup | null
): FokParameterChoiceInput[] => {
  return parameterChoicesInput.map<FokParameterChoiceInput>(({ fokParameter }) => {
    const activeParam = activeMarkup?.fokParameterChoices.find(
      activeParam => activeParam.parameterValue === fokParameter.parameterValue
    );

    // If end date had a value but now doesn't
    const hasChangedToUntilFurtherNotice = !!activeParam?.endDate && !fokParameter.endDate;

    return {
      ...fokParameter,
      endDate: hasChangedToUntilFurtherNotice ? HIGH_DATE_S4I : fokParameter.endDate,
    };
  });
};
